import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AccountService } from '@teacher/services/account.service';

import { ResponseProfile } from '@app/_interfaces/responses';

@Injectable({
    providedIn: 'root'
})
export class ProfileResolver implements Resolve<ResponseProfile> {
    constructor(private accountService: AccountService) {}

    resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<ResponseProfile> {
        return this.accountService.getProfileData();
    }
}
